import { aboutPoints } from "@/mocks/colors";

export default function AboutContact() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          {/* 关于 */}
          <div>
            <p className="flex items-center gap-3 text-accent-700 text-xs tracking-display uppercase">
              <span className="font-number text-lg">06</span>
              <span className="inline-block w-8 h-px bg-accent-500" />
              关于图鉴
            </p>
            <h2 className="mt-4 font-serif text-foreground-950 text-2xl md:text-[32px] font-semibold leading-snug">
              一份把「黑」研究到位的独立色卡资料库
            </h2>
            <p className="mt-5 text-[15px] leading-8 text-foreground-600">
              「黑料色」是一份专注黑色系色彩整理的独立图鉴。我们相信黑并非「没有颜色」，而是
              一种由底调、明度与光泽共同塑造的丰富语言。因此我们围绕黑料色的色号做分类归档，
              把炭黑、曜石、石墨、烟灰、玄青与暖黑六条脉络整理成清晰可查的合集，
              让设计师与配色从业者在找黑色系时不必漫无目的地翻找。
            </p>
            <p className="mt-3 text-[15px] leading-8 text-foreground-600">
              图鉴里每个色号都给出可复现的色卡参数与使用场景，力求从屏幕到印刷、从样品到量产，
              都尽量有据可依。
            </p>

            <div className="mt-8 flex flex-col gap-5">
              {aboutPoints.map((p, i) => (
                <div key={p.title} className="flex gap-4">
                  <span className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 font-number">
                    {i + 1}
                  </span>
                  <div>
                    <h3 className="text-foreground-950 font-medium">{p.title}</h3>
                    <p className="mt-1 text-[14px] leading-6 text-foreground-600">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 联系方式与口碑 */}
          <div className="flex flex-col gap-5" id="contact">
            <div className="rounded-lg border border-accent-200 bg-background-100/80 p-6 md:p-7">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-mail-send-line text-lg" />
                </span>
                <div>
                  <h3 className="text-foreground-950 font-medium">与我们交流</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">反馈缺号 / 勘误 / 共建色系</p>
                </div>
              </div>
              <a
                href="mailto:hello@heiliaose.example.com"
                className="mt-5 inline-flex items-center gap-2 text-accent-700 hover:text-accent-900 text-sm font-medium"
              >
                hello@heiliaose.example.com
                <i className="ri-external-link-line" />
              </a>
              <p className="mt-4 text-[13px] leading-6 text-foreground-500">
                若你手头有缺失的黑料色系素材，欢迎来信，编辑部会评估后纳入后续图鉴归档。
              </p>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100/60 p-6 md:p-7">
              <h3 className="text-foreground-950 font-medium">编辑原则</h3>
              <ul className="mt-4 space-y-3">
                {[
                  { icon: "ri-archive-line", t: "先归类再入库，色号清晰可追溯" },
                  { icon: "ri-palette-line", t: "色值可复现，交付有据可依" },
                  { icon: "ri-refresh-line", t: "随工艺与流行持续补充新黑" },
                  { icon: "ri-scales-3-line", t: "客观标注，不标注未经证实的信息" },
                ].map((it) => (
                  <li key={it.t} className="flex items-start gap-3 text-[14px] text-foreground-700">
                    <i className={`${it.icon} text-accent-600 mt-0.5`} />
                    {it.t}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}